import React from 'react';
import { Tooltip, TooltipProps } from '@fluentui/react-components';
import './GuideComponents.css';

export type GuideTooltipProps = Omit<TooltipProps, 'content' | 'withArrow' | 'appearance'> & {
  content: string;
};

/**
 * Tooltip de la guía ("Ayudas y mensajes"): fondo oscuro, texto blanco, 13 px, radio 4 y sin flecha;
 * aparece al pasar el mouse o con foco. Colores en `--ichtys-tooltip-*` (alto contraste: negro con borde blanco).
 */
export const GuideTooltip = ({ content, ...rest }: GuideTooltipProps) => (
  <Tooltip {...rest} content={{ children: content, className: 'ichtys-tooltip' }} withArrow={false} />
);

// Igual que el Tooltip de Fluent: es un "trigger" transparente, así MenuTrigger / PopoverTrigger
// pasan sus props al botón de adentro (<MenuTrigger><GuideTooltip><Button/></GuideTooltip></MenuTrigger>).
(GuideTooltip as unknown as { isFluentTriggerComponent: boolean }).isFluentTriggerComponent = true;

export default GuideTooltip;
